import { render } from "./ProjectList.vue?vue&type=template&id=88458fa4&ts=true"
import script from "./ProjectList.vue?vue&type=script&lang=ts"
export * from "./ProjectList.vue?vue&type=script&lang=ts"

import "./ProjectList.vue?vue&type=style&index=0&id=88458fa4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__